import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'vq-input-date-am',
  templateUrl: './form-input-date-am.component.html',
  styles: []
})
export class FormInputDateAmComponent implements OnInit {

	@ViewChild('input') inputElRef: ElementRef;
  @Input('vqModel') model:any;
  @Input('vqCheckboxModel') checkboxmodel:any;
  @Input('vqLabel') label:string;
  @Input('vqCheckboxLabel') checkboxlabel:string;
  @Input('vqStep') step:string = 'any';
  @Input('vqPlaceholder') placeholder:string;
  @Input('vqErrors') errors:Array<string> = [];
  @Input('vqHelpText') helpText:string;
  @Input('vqDebounce') debounce:number = 0;
  @Input('vqDefaultValue') defaultValue:any = '';

  @Output('vqTrigger') trigger:EventEmitter<any> = new EventEmitter<any>();
  @Output('vqModelChange') modelChange:EventEmitter<any> = new EventEmitter<any>();
  @Output('vqCheckboxModelChange') checkboxmodelChange:EventEmitter<any> = new EventEmitter<any>();

  id:string;

  constructor() { }

  private _isString(v) {
    return typeof v === 'string';
  }

  private setVqId() {
  	this.id = Math.random().toString(36).substr(2, 8);
  }

  ngOnInit() {
  	this.setVqId();
    Observable.fromEvent(this.inputElRef.nativeElement, 'input')
      .debounceTime(this.debounce)
      .subscribe((keyboardEvent:any) => {
        this.modelChange.emit(this.model);
      })
  }

  public change(event) {
    if (this._isString(event)) {
      this.model = event;
      this.modelChange.emit(this.model);
    } else {
      this.checkboxmodel = event;
      this.checkboxmodelChange.emit(this.checkboxmodel);
    }
  }

  public hasError() {
  	return (this.errors && this.errors.length > 0);
  }

  public onKeyPress($event) {
    if ($event.keyCode == 13) {
      this.trigger.emit($event.target.value);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/vqforms/form-input-date-am/form-input-date-am.component.ts